/* eslint-disable no-restricted-imports */
import {
  Chip,
  CircularProgress,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from '@material-ui/core';
import { Delete, Edit } from '@material-ui/icons';

import { FormatDate, FormatMoney } from 'components';

import { useStyles } from '../styles';

export function ComponentsTable({
  components,
  loading,
  totalCount,
  page,
  rowsPerPage,
  handleChangePage,
  handleChangeRowsPerPage,
  handleEdit,
  handleDelete,
}) {
  const classes = useStyles();

  return (
    <>
      <TableContainer component={Paper} elevation={0}>
        <Table className={classes.table}>
          <TableHead className={classes.tableHeader}>
            <TableRow>
              <TableCell>Part Number</TableCell>
              <TableCell>Descrição</TableCell>
              <TableCell align='right'>Valor Venda</TableCell>
              <TableCell align='right'>Valor Custo</TableCell>
              <TableCell>Processos</TableCell>
              <TableCell>Última Atualização</TableCell>
              <TableCell align='center'>Ações</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={7} className={classes.noDataContainer}>
                  <CircularProgress />
                </TableCell>
              </TableRow>
            ) : components?.length === 0 ? (
              <TableRow>
                <TableCell colSpan={7} className={classes.noDataContainer}>
                  <Typography variant='subtitle1' color='textSecondary'>
                    Nenhum produto encontrado
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              components.map((product) => (
                <TableRow key={product?.id} hover>
                  <TableCell>
                    <Typography variant='body1' style={{ fontWeight: 500 }}>
                      {product.part_number}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant='body1' style={{ fontWeight: 500 }}>
                      {product.description}
                    </Typography>
                  </TableCell>
                  <TableCell align='right'>
                    <FormatMoney>{product?.sell_price ?? 0}</FormatMoney>
                  </TableCell>
                  <TableCell align='right'>
                    <FormatMoney>{product?.cost_price ?? 0}</FormatMoney>
                  </TableCell>
                  <TableCell>
                    <Chip label={product?.process} size='small' className={classes.processChip} />
                  </TableCell>
                  <TableCell>
                    <FormatDate>{product?.created_at ?? new Date()}</FormatDate>
                  </TableCell>
                  <TableCell align='center'>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                      <IconButton onClick={() => handleEdit(product)} color='primary'>
                        <Edit />
                      </IconButton>
                      <IconButton onClick={() => handleDelete(product)} color='secondary'>
                        <Delete />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {!loading && components?.length > 0 && (
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component='div'
          count={totalCount || 0}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage='Itens por página:'
          labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
        />
      )}
    </>
  );
}
